// extracted by mini-css-extract-plugin
export default {"data_view_buttons":"DataView_data_view_buttons__iCqPt","data_view_icon":"DataView_data_view_icon__eO2cl"};